import React, { useState } from "react";
import { Search } from "lucide-react";

import { SidebarMenu } from "./SidebarMenu";

export function SideBar() {
  const [searchQuery, setSearchQuery] = useState("");

  return (
    <div className="flex flex-no-wrap min-h-screen ">
      {/* Sidebar starts */}
      {/* Remove class [ hidden ] and replace [ sm:flex ] with [ flex ] */}
      <div className="w-48 absolute sm:relative bg-slate-900 shadow md:h-full flex-col justify-between hidden sm:flex ">
        <div className="w-full h-screen overflow-y-auto pb-5">
          <div className="w-full flex items-center justify-center p-4">
            <img className="w-20" src="/logo-white.png" alt="CHESTA" />
          </div>
          {/* Search Input */}
          <div className="px-4 mb-4">
            <div className="relative group">
              <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                <Search className="h-4 w-4 text-gray-400 group-focus-within:text-gray-300 transition-colors" />
              </div>
              <input
                type="text"
                placeholder="Search menu..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="w-full px-3 py-2.5 pl-10 bg-slate-800/70 border border-slate-700/50 text-white placeholder-gray-400 rounded-lg focus:outline-none focus:ring-2 focus:ring-cyan-500/50 focus:border-cyan-500/50 text-sm transition-all duration-200 hover:bg-slate-800 hover:border-slate-600/50 shadow-sm"
              />
            </div>
          </div>
          <SidebarMenu searchQuery={searchQuery} />
        </div>
      </div>
      {/* Sidebar ends */}
    </div>
  );
}
